import type { TableColumnType, TableRowType, TableType } from '../../../../grid/reduxStore/table.types';
import { getTextRowsWithCalculatedSubtotals } from './calculateSubTotalsPerRow';
import { updateTotalRowsWithSubtotalCalculation } from './updateTotalRowsWithSubtotalCalculation';

export type UpdatedTableTotals = {
  totalRows: TableType['totalRows'];
  metadata: TableType['metadata'];
  sumOfSubtotalColumn: number;
};

export function buildUpdatedTableTotals(sumOfSubtotalColumn: number, tableData: TableType): UpdatedTableTotals {
  const shouldRecalculate = !!tableData.totalRows && tableData.metadata?.tableSubTotal !== sumOfSubtotalColumn;

  const totalRowsWithSubtotals = shouldRecalculate
    ? updateTotalRowsWithSubtotalCalculation(tableData.totalRows!, sumOfSubtotalColumn)
    : tableData.totalRows;

  const tableTotal = totalRowsWithSubtotals?.[totalRowsWithSubtotals.length - 1]?.subtotal;

  // `subtotal` is derived from `price` at render time; strip it so stale values are never persisted
  const totalRows = totalRowsWithSubtotals
    ? totalRowsWithSubtotals.map(({ subtotal: _subtotal, ...row }) => row as TableRowType)
    : totalRowsWithSubtotals;

  return {
    totalRows,
    metadata: {
      ...tableData.metadata,
      tableTotal,
    },
    sumOfSubtotalColumn,
  };
}

export function getUpdatedTableTotals(rows: TableRowType[], columns: TableColumnType[], tableData: TableType): UpdatedTableTotals {
  const { sumOfSubtotalColumn } = getTextRowsWithCalculatedSubtotals(rows, columns);
  return buildUpdatedTableTotals(sumOfSubtotalColumn, tableData);
}
